import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';

import serviceIcon1 from '../../assets/img/service/icons/1.png';
import serviceIcon2 from '../../assets/img/service/icons/2.png';
import serviceIcon3 from '../../assets/img/service/icons/3.png';
import serviceIcon4 from '../../assets/img/service/icons/4.png';
import serviceIcon5 from '../../assets/img/service/icons/5.png';
import serviceIcon6 from '../../assets/img/service/icons/6.png';
import serviceIcon7 from '../../assets/img/service/icons/7.png';
import serviceIcon8 from '../../assets/img/service/icons/8.png';

const Service = () => {

    return (
        <div id="rs-service" className="rs-services main-home gray-bg pt-110 pb-120 md-pt-70 md-pb-70">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-46"
                    subtitleClass="sub-text"
                    subtitle="Services"
                    titleClass="title"
                    title="Our Featured Services"
                    descClass="desc"
                    desc="Everything from custom software to AI automation"
                    effectClass="heading-line"
                />
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon1}
                            serviceURL="software-development"
                            Title="Software Development" 
                            Text="We help businesses design, build, and implement custom software solutions tailored to your specific needs and goals." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon2}
                            serviceURL="web-development"
                            Title="Web Development" 
                            Text="We design and develop custom web applications, websites, and e-commerce platforms using the latest technologies and frameworks." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon3}
                            serviceURL="analytic-solutions"
                            Title="Analytic Solutions" 
                            Text="We help businesses gain insights from their data, develop predictive models, and make informed, data-driven decisions." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 md-mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon4}
                            serviceURL="cloud-devops"
                            Title="Cloud & DevOps" 
                            Text="We optimise your cloud infrastructure and implement DevOps practices to streamline development and reduce time-to-market." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 sm-mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon5}
                            serviceURL="mvp-development"
                            Title="MVP Development" 
                            Text="We help businesses develop a Minimum Viable Product quickly and cost-effectively using agile methodologies to validate your ideas fast." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon6}
                            serviceURL="report-automation"
                            Title="Report Automation" 
                            Text="We automate your reporting processes with custom solutions that save time, reduce errors, and improve the accuracy of your data." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon7}
                            serviceURL="ai-workflow-automation"
                            Title="AI Workflow Automation" 
                            Text="We identify where AI can make the biggest impact and implement automation that works — from intelligent chatbots to end-to-end workflow pipelines using n8n, Make, and Zapier. We deliver practical automation that pays for itself." 
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-30">
                        <SingleService 
                            itemClass="services-item"
                            serviceImage={serviceIcon8}
                            serviceURL="ai-consulting"
                            Title="AI Consulting & Strategy" 
                            Text="Not sure where to start with AI? We offer AI Workflow Audits and strategic roadmaps to help your business adopt AI — without the enterprise price tag. Book a free AI Workflow Audit to find out where you're leaving time and money on the table." 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service;